import { useSelector } from "react-redux";

export default function useCommonData() {
  let metaData = useSelector(state => state.common.metaData);
  if(!metaData){
    metaData = JSON.parse(localStorage.getItem("metaData"))
  }
  return {metaData}
}